module.exports = __webpack_public_path__ + "media/images/re/evelyn-paris-95853-unsplash-6eed9c8a932cafc035a63b23ed883354.png";